// Minimal table wrapper. Each column = { key, label, render?(row), style? }.
// Outer .data-table-wrap makes the table horizontally scrollable on small
// screens without breaking the surrounding page layout.

import React from 'react';
import './DataTable.css';

export default function DataTable({ columns, rows, emptyMessage = 'No results.' }) {
  if (!rows || rows.length === 0) {
    return <div className="portal-empty">{emptyMessage}</div>;
  }
  return (
    <div className="data-table-wrap">
      <table className="data-table">
        <thead>
          <tr>
            {columns.map(c => (
              <th key={c.key} style={c.style || {}}>{c.label}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, i) => (
            <tr key={row.id ?? i}>
              {columns.map(c => (
                <td key={c.key}>
                  {c.render ? c.render(row) : row[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
